/**
 * Screen-saver stop evidence (Paul, Oct 23 2026) — logging only, no behaviour change.
 * These reach the fleet snapshot (console.debug / console.log lines do not), so the next
 * "music stopped while the screen was dark" report shows whether the next track was armed
 * and how late the web's wall-clock advance timer actually fired.
 */
import { diagnosticLog } from '../utils/diagnosticLogger';
import { useMaestroStore } from '../store/maestroStore';

function visibility(): string | null {
  return typeof document !== 'undefined' ? document.visibilityState : null;
}

/** SetNext prefetch outcome. `reason === undefined` means the next track was armed on the renderer. */
export function logSetNextPrefetchOutcome(reason: string | undefined, queueIndex: number): void {
  const renderer = useMaestroStore.getState().activeConnectorRenderer as
    | { id?: string; avt_supports_set_next?: boolean; gapless_enabled?: boolean }
    | null
    | undefined;
  diagnosticLog('info', 'playback', 'setnext_prefetch', {
    outcome: reason === undefined ? 'armed' : reason.startsWith('failed') ? 'failed' : 'skipped',
    reason: reason ?? null,
    queue_index: queueIndex,
    renderer_id: renderer?.id ?? null,
    avt_supports_set_next: renderer?.avt_supports_set_next ?? null,
    gapless_enabled: renderer?.gapless_enabled ?? null,
    visibility: visibility(),
  });
}

/** Wall-clock / fallback advance timer fired: lateness against the time it was scheduled for. */
export function logAdvanceTimerFired(scheduledAtMs: number, fallback: boolean, trackId: string | null): void {
  diagnosticLog('info', 'playback', 'advance_timer_fired', {
    late_ms: Math.round(Date.now() - scheduledAtMs),
    fallback,
    trackId,
    visibility: visibility(),
  });
}
